module.exports = __webpack_public_path__ + "static/media/male-non-traditional.a63022c9.mp4";